export default __webpack_public_path__ + "static/media/leave-blue.67f61589.svg";